import { UPDATE_GLOBAL_SETUP } from './globalSetup.actions';

import initialState from './globalSetupInitialValues';

/**
 * @param {GlobalSetup.GlobalSetupAppData} state
 * @param {ShiftBidding.IAction} action
 * */
// eslint-disable-next-line default-param-last
const globalSetupAppDataReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case UPDATE_GLOBAL_SETUP:
            return {
                ...state,
                ...payload,
            };
        default:
            return state;
    }
};

export default globalSetupAppDataReducer;
